/**
 * API Configuration Module
 * Centralized configuration for API endpoints and environment-specific settings
 */

// Environment detection
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';
export const isTest = process.env.NODE_ENV === 'test';

// API Configuration
export const apiConfig = {
  // Base URLs for different environments
  development: {
    baseURL: 'http://localhost:8000',
    timeout: 30000,
  },
  production: {
    baseURL: process.env.REACT_APP_API_URL || 'https://api.bunzz-ocr.com',
    timeout: 30000,
  },
  test: {
    baseURL: 'http://localhost:8000',
    timeout: 5000,
  },
};

// Get current environment configuration
export const getCurrentConfig = () => {
  if (isDevelopment) return apiConfig.development;
  if (isTest) return apiConfig.test;
  return apiConfig.production;
};

// Smart API URL detection
export const getApiUrl = () => {
  // If explicitly set via environment variable, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Auto-detect based on current location (for runtime configuration)
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    
    // Development detection
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return isDevelopment ? 'http://localhost:8000' : 
             (protocol === 'https:' ? 'https://localhost' : 'http://localhost:8000');
    }
    
    // Production deployment - match current protocol and hostname
    const port = protocol === 'https:' ? '' : ':8000';
    return `${protocol}//${hostname}${port}`;
  }
  
  // Fallback to environment-specific defaults
  return getCurrentConfig().baseURL;
};

// Logging configuration
export const logConfig = {
  enableApiLogging: isDevelopment || process.env.REACT_APP_ENABLE_API_LOGGING === 'true',
  logLevel: process.env.REACT_APP_LOG_LEVEL || (isDevelopment ? 'debug' : 'error'),
};

// Feature flags
export const features = {
  enableDebugMode: isDevelopment || process.env.REACT_APP_DEBUG === 'true',
  enablePerformanceMonitoring: process.env.REACT_APP_ENABLE_MONITORING === 'true',
  enableExperimentalFeatures: process.env.REACT_APP_EXPERIMENTAL === 'true',
};

// Export environment information
export const environment = {
  name: process.env.NODE_ENV,
  version: process.env.REACT_APP_VERSION || '1.0.0',
  buildTime: process.env.REACT_APP_BUILD_TIME || new Date().toISOString(),
  apiUrl: getApiUrl(),
  isDevelopment,
  isProduction,
  isTest,
};